module.exports = __webpack_public_path__ + "img/energy-tank.af0440b0.svg";